import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/billingPaymentTrack/excelPreviewStyle';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { translate } from 'components/Translation';
import { BodyS } from 'components/Typography/Typography';
import TableHeader from 'components/TableHeader/TableHeader';
import CustomTable from 'components/CustomTable/CustomTable';
import React, { useMemo, useState } from 'react';
import { INVOICE_TYPE } from 'views/BillingPaymentTrack/commons/constants';
import moment from 'moment';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IExcelPreviewDialog {
	isOpen: boolean;
	hideDialog: () => void;
	excelPreviewData: Object[];
	invoiceType: string;
}

const ExcelPreviewDialog = ({ isOpen, hideDialog, excelPreviewData, invoiceType }: IExcelPreviewDialog) => {
	const classes = useStyles();
	const [searchValue, setSearchValue] = useState<string>('');
	const filteredRows: Object[] = (excelPreviewData.slice(1) || []).filter((row) => {
		return String(row['A']).includes(searchValue.toLowerCase());
	});

	const columns = useMemo(() => {
		if (invoiceType === INVOICE_TYPE.ACCOUNT) {
			return [
				{
					accessor: 'A',
					Header: translate('billing.payment.track.preview.excel.account.number'),
					Cell: function AccountNumberCell({ original }: { original: string }) {
						return <div>{original['A']}</div>;
					},
					sortable: true,
				},
				{
					accessor: 'B',
					Header: translate('billing.payment.track.preview.excel.payment.date'),
					Cell: function PaymentDateCell({ original }: { original: any }) {
						const momentPaymentDate = moment(original['B']).format('DD/MM/YYYY');
						if (original['B']) {
							return <div>{momentPaymentDate.toString()}</div>;
						} else {
							return <div></div>;
						}
					},
					sortable: true,
				},
				{
					accessor: 'C',
					Header: translate('amount'),
					Cell: function AmountCell({ original }: { original: string }) {
						return <div>{original['C']}</div>;
					},
					sortable: true,
				},
			];
		} else {
			return [
				{
					accessor: 'A',
					Header: translate('billing.payment.track.preview.excel.account.number'),
					Cell: function AccountNumberCell({ original }: { original: string }) {
						return <div>{original['A']}</div>;
					},
					sortable: true,
				},
				{
					accessor: 'B',
					Header: translate('billing.payment.track.preview.excel.invoice.number'),
					Cell: function InvoiceNumberCell({ original }: { original: string }) {
						return <div>{original['B']}</div>;
					},
					sortable: true,
				},
				{
					accessor: 'C',
					Header: translate('billing.payment.track.preview.excel.payment.date'),
					Cell: function PaymentDateCell({ original }: { original: string }) {
						const momentPaymentDate = moment(original['C']).format('DD/MM/YYYY');
						if (original['C']) {
							return <div>{momentPaymentDate.toString()}</div>;
						} else {
							return <div></div>;
						}
					},
					sortable: true,
				},
				{
					accessor: 'D',
					Header: translate('amount'),
					Cell: function AmountCell({ original }: { original: string }) {
						return <div>{original['D']}</div>;
					},
					sortable: true,
				},
			];
		}
	}, [invoiceType]);

	return (
		<CustomDialog
			header={translate('billing.payment.track.preview.excel.heading')}
			description={
				<BodyS color="secondary-light">{translate('billing.payment.track.preview.excel.reason')}</BodyS>
			}
			isOpen={isOpen}
			hideDialog={hideDialog}
			loading={false}
			width={668}
			dialogBody={
				<div className={classes.tableWrapper}>
					<TableHeader
						searchInputValue={searchValue}
						setSearchInputValue={(value) => setSearchValue(value)}
					/>

					<CustomTable
						withHeader
						total={(filteredRows || [])?.length}
						tableProps={{
							data: filteredRows,
							columns,
							defaultPageSize: 5,
						}}
					/>
				</div>
			}
		/>
	);
};

export default ExcelPreviewDialog;
